import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["sections"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useShowDebugging } from '~/functions/accounts';
import { EnumIroType, useGetAccountQuery, useListEsrsSectionsQuery, useUpsertAccountSectionLinkMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Esrs',
  setup: function setup(__props) {
    var showDebugging = useShowDebugging();
    var route = useRoute();
    var attrs = useAttrs();
    var fullHeaders = computed(function () {
      var baseHeaders = [showDebugging.value ? {
        value: 'id',
        sortable: true,
        width: '25px'
      } : null, {
        value: 'name',
        width: '200px'
      }, {
        value: 'status',
        width: '200px'
      }, {
        value: 'positiveImpacts',
        width: '200px'
      }, {
        value: 'negativeImpacts',
        width: '200px'
      }, {
        value: 'risks',
        width: '200px'
      }, {
        value: 'opportunities',
        width: '200px'
      }, {
        value: 'comment',
        width: '200px'
      }].filter(function (o) {
        return o !== null;
      });
      return baseHeaders.filter(function (o) {
        var _attrs$headers;
        return attrs === null || attrs === void 0 ? void 0 : (_attrs$headers = attrs.headers) === null || _attrs$headers === void 0 ? void 0 : _attrs$headers.includes(o.value);
      }).map(function (col) {
        return _objectSpread(_objectSpread({}, col), {}, {
          sortable: col.sortable || false
        });
      });
    });
    var search = ref('');
    var variables = computed(function () {
      var iroLinkFilter = ref();
      if (route.query.status === 'notAssigned') {
        iroLinkFilter.value = false;
      } else if (route.query.status === 'assigned') {
        iroLinkFilter.value = true;
      } else if (route.query.status === 'all') {
        iroLinkFilter.value = null;
      }
      return {
        filters: {
          parentIds: [1500],
          iroLink: iroLinkFilter.value
        }
      };
    });
    var _useListEsrsSectionsQ = useListEsrsSectionsQuery(variables),
      result = _useListEsrsSectionsQ.result,
      refetch = _useListEsrsSectionsQ.refetch,
      loading = _useListEsrsSectionsQ.loading;
    var _flattenSections = function flattenSections(sections) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return sections.reduce(function (acc, section) {
        var childSections = section.sections,
          sectionData = _objectWithoutProperties(section, _excluded);
        acc.push(_objectSpread(_objectSpread({}, sectionData), {}, {
          level: level,
          parentId: parentId,
          hasChildren: childSections && childSections.length > 0
        }));
        if (childSections && childSections.length > 0) {
          acc.push.apply(acc, _toConsumableArray(_flattenSections(childSections, level + 1, section.id)));
        }
        return acc;
      }, []);
    };
    var items = computed(function () {
      var _result$value;
      return _flattenSections(((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listSections) || []);
    });
    var expanded = ref([]);
    var dataLoaded = computed(function () {
      return !loading.value && items.value.length > 0;
    });

    // Expand all top-level items when data is loaded
    watchEffect(function () {
      if (dataLoaded.value && expanded.value.length === 0) {
        expanded.value = items.value.filter(function (item) {
          return item.level === 0;
        });
      }
    });
    var transformedItems = computed(function () {
      var topLevel = items.value.filter(function (item) {
        return item.level === 0;
      });
      return topLevel;
    });
    var rowClasses = function rowClasses(item) {
      return item.hasChildren ? 'font-bold bg-gray-50' : '';
    };
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var _useUpsertAccountSect = useUpsertAccountSectionLinkMutation(),
      mutate = _useUpsertAccountSect.mutate;
    var getCommentValue = function getCommentValue(item) {
      if (Array.isArray(item === null || item === void 0 ? void 0 : item.accountLinks) && item.accountLinks.length > 0) {
        var _item$accountLinks$0$;
        return (_item$accountLinks$0$ = item.accountLinks[0].comment) !== null && _item$accountLinks$0$ !== void 0 ? _item$accountLinks$0$ : '';
      }
      return '';
    };
    var upsertAccountLink = function upsertAccountLink(section, val) {
      var _account$value;
      mutate({
        input: {
          accountId: account === null || account === void 0 ? void 0 : (_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.id,
          sectionId: section.id,
          comment: val
        }
      });
    };
    return {
      __sfc: true,
      showDebugging: showDebugging,
      route: route,
      attrs: attrs,
      fullHeaders: fullHeaders,
      search: search,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      flattenSections: _flattenSections,
      items: items,
      expanded: expanded,
      dataLoaded: dataLoaded,
      transformedItems: transformedItems,
      rowClasses: rowClasses,
      accountResult: accountResult,
      account: account,
      mutate: mutate,
      getCommentValue: getCommentValue,
      upsertAccountLink: upsertAccountLink,
      EnumIroType: EnumIroType
    };
  }
});